"use strict";
window.sendMessage = (message, origin) => {
    console.log(`sending message ${message} ${origin}`);
    try {
        window.parent.postMessage(message, "*");
    }
    catch (e) {
        console.warn(e);
    }
};
window.sendObject = (message, origin) => {
    window.parent.postMessage(message, "*");
};
window.triggerClick = (elt) => {
    elt.click();
};
window.openModal = (elt) => {
    const myModal = document.getElementById(elt);
    myModal.classList.add("show");
    myModal.style.display = "block";
};
window.registerDotNetInstance = (instance) => {
    window.dotnetInstance = instance;
};
window.addEventListener('message', event => {
    let d = window.dotnetInstance;
    if (d) {
        d.invokeMethodAsync("parentMessageEvent", event.data);
    }
    else {
        console.log("no dotnet instance loaded");
    }
});
//# sourceMappingURL=webchatworker.js.map